import { render, staticRenderFns } from "./familyInfoAddEdit.vue?vue&type=template&id=17157684&scoped=true&"
import script from "./familyInfoAddEdit.vue?vue&type=script&lang=js&"
export * from "./familyInfoAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./familyInfoAddEdit.vue?vue&type=style&index=0&id=17157684&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17157684",
  null
  
)

export default component.exports